(function (window, angular, undefined) {
    angular.module('formApp')
        .directive('clearProducts', ['FormService', 'formData', '$templateCache', '$document', '$compile', 'errorHandler', 'LoadingInterceptor',
            function (formService, formData, $templateCache, $document, $compile, errorHandler, loadingInterceptor) {
            var template = $templateCache.get('directives/clear-products/templates/clear-products.html');
            return {
                scope: {
                    petId: "=ddPet",
                    clearProduct: '&'
                },
                link: function($scope, element) {

                    var childScope,
                        popup,
                        bodyEl = $document.find('body'),
                        openModalButton = document.activeElement;

                    $scope.formData = formData;    
                        
                    $scope.clearOlderRabbit = function() {
                        var pet = formData.pets[$scope.petId];
                        // console.log('fired');
                        // console.log('pet id', pet);
                        // console.log('data', $scope.formData);
                        removePopup();
                        // use parent function in step 3 controller
                        $scope.clearProduct(pet);
                    };

                    $scope.close = function() {
                        removePopup();
                        openModalButton.focus();
                    };

                    function removePopup() {
                        childScope.$destroy();
                        popup.remove();
                    }
                    
                    element.on('click', function() {
                        if (popup) {
                            removePopup();
                        }
                        $scope.$apply(function() {
                            $scope.pet = formData.pets[$scope.petId];
                            childScope = $scope.$new();
                            popup = $compile(template)(childScope);
                            bodyEl.append(popup);

                            //Accessibility - focus in modal window
                            var modalMain = document.getElementById('rabbitOldPet'),
                            p = document.getElementById('skipnav'),
                            modal = document.querySelector('#rabbitOldPet .modal-dialog'),
                            closeModalButton = document.querySelector('#rabbitOldPet .modal-close'),
                            returnQuote = document.querySelector('#rabbitOldPet .return-quote'); 

                            swap();  

                            focusDialog();                  
                                                                      
                            function focusDialog(){  
                                angular.element(modalMain).attr({ 'aria-hidden': 'false','tab-index': '0','open': true});  

                                modal.focus();

                                angular.element(closeModalButton).on('keydown', function(e){
                                    if ((e.which === 9 && !e.shiftKey)) {
                                        e.preventDefault();
                                        modal.focus();
                                   }
                                });

                                angular.element(modal).on('keydown', function(e){
                                    if ((e.which === 9 && e.shiftKey)) {
                                        e.preventDefault();        
                                        closeModalButton.focus();
                                    }
                                }); 
                            }                                       

                            function swap(){
                                p.parentNode.insertBefore(modalMain, p);
                            } 
                           //end of accessibility

                        });
                    });
                }
            };
        }]);
})(window, window.angular);
